

















































import { namespace } from 'vuex-class'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { ProcedureId } from '@/Domain/Procedures'
import {
  FetchBatchesFromProcedureCommandHandlerProvider
} from '@/Infrastructure/Batch/Persistence/Provider'
import {
  SendAuctionACommandHandlerProvider
} from '@/Infrastructure/AuctionA/Provider'
import { SendAuctionACommand } from '@/Application/AuctionA'
import {
  FetchBatchesFromProcedureCommand,
  ProcedureBatchesDto,
  BatchDto
} from '@/Application/Batch'
import { ProcedureDto } from '@/Application/Procedures'
import AuctionWizardHeader from '@/UI/Auction/AuctionWizardHeader.vue'
import PersonalDataLayout from '@/UI/Auction/PersonalData/PersonalDataLayout.vue'
import Notifications from '@/UI/Auction/Notifications/Notifications.vue'
import Procedure from '@/UI/Auction/Procedure/Procedure.vue'
import Statements from '@/UI/Auction/Statements/Statements.vue'
import Documentations from '@/UI/Auction/Documentations/Documentations.vue'
import Verifications from '@/UI/Auction/Verifications/Verifications.vue'
import Protection from '@/UI/Auction/Protection/Protection.vue'
import { StepValidation } from '@/UI/Shared/StepValidation'
import Footer from '@/UI/Auction/AuctionFooter.vue'
import { EventBus } from '@/Infrastructure/EventBus/EventBus'
import { SweetAlertResult } from 'sweetalert2'
import { PersonalData as VuexPersonalData } from '@/Infrastructure/Store/Auction/PersonalData'
import { MessageAlert } from '@/Domain/MessageAlert'

const procedureStore = namespace('procedure')
const auctionStore = namespace('auction')
const auctionStoreB = namespace('auctionb')
const accountStore = namespace('account')

@Component({
  components: {
    AuctionWizardHeader,
    Notifications,
    Procedure,
    Statements,
    Documentations,
    Verifications,
    Protection,
    PersonalDataLayout,
    Footer
  }
})
export default class Auction extends Vue {
  loadingSetp1 = true
  validForm = false
  currentStep = 1
  lastValidatedStep = 1
  validQuery = true

  @accountStore.Getter
  public accountId!: string

  @auctionStore.Getter
  public personalData!: VuexPersonalData

  @procedureStore.Getter
  public currentProcedure!: ProcedureDto

  @procedureStore.Action
  public setCurrentProcedure!: (procedureDto: ProcedureDto) => void

  @procedureStore.Action
  public setProcedureBatches!: (payload: { risco: BatchDto[]; resultas: BatchDto[] }) => void

  @auctionStore.Getter
  public procedureData!: string[]

  @auctionStore.Getter
  public lastWizardStep!: number

  @auctionStore.Getter
  public procesedAuctionA!: boolean

  @auctionStore.Action
  public setLastWizardStep!: (number: number) => void

  @auctionStore.Action
  public setProcesedAuctionA!: (number: boolean) => void

  @auctionStoreB.Action
  public clearAuctionB!: () => void

  @Watch('lastValidatedStep')

  onChangeCurrentStep (newValue: number): void {
    this.setLastWizardStep(newValue)
  }

  beforeMount (): void {
    const currentProcedureId = this.currentProcedure ? this.currentProcedure.procedureId : ''
    const routeProcedureId = this.$route.params.procedureId
    if (currentProcedureId !== routeProcedureId) {
      EventBus.$emit('loading', true)
      this.setProcesedAuctionA(false)
      this.loadData(routeProcedureId)
        .finally(() => {
          EventBus.$emit('loading', false)
          this.loadingSetp1 = false
        })
    } else if (this.procesedAuctionA) {
      this.$router.push({ name: 'AuctionB', params: { procedureId: currentProcedureId } })
    } else {
      this.loadingSetp1 = false
      this.currentStep = this.lastWizardStep
      if (this.lastValidatedStep <= this.lastWizardStep) {
        this.lastValidatedStep = this.lastWizardStep
      }
    }
  }

  public loadData (procedureId: string): Promise<void> {
    return this.loadBatches(new ProcedureId(procedureId))
      .then((response: ProcedureBatchesDto) => {
        this.setCurrentProcedure(response.procedure)
        this.setProcedureBatches({
          risco: response.batches.RISCO,
          resultas: response.batches.RESUL
        })
      })
  }

  public loadBatches (procedureId: ProcedureId): Promise<ProcedureBatchesDto> {
    const provider = new FetchBatchesFromProcedureCommandHandlerProvider()
    const command = new FetchBatchesFromProcedureCommand(procedureId)
    const handler = provider.provide()
    return handler.handle(command)
  }

  public checkValidForm (valid: StepValidation): void {
    if (valid.validForm === true && valid.step <= this.currentStep) {
      this.validForm = true
    } else {
      this.validForm = false
    }
  }

  public onWizardFinished (): void {
    this.$swal({
      title: this.$t('shared.atencion').toString(),
      text: this.$t('subasta.final.warning').toString(),
      icon: 'warning',
      showCancelButton: true,
      width: 400
    }).then((result: SweetAlertResult) => {
      if (result.value) {
        return this.sendData()
      }
    })
  }

  public sendData (): void {
    this.clearAuctionB()
    const provider = new SendAuctionACommandHandlerProvider()
    const command = new SendAuctionACommand(
      this.currentProcedure.procedureId,
      this.accountId,
      this.procedureData.sort().join('-')
    )
    const handler = provider.provide()
    EventBus.$emit('loading', true)
    handler.handle(command)
      .then(() => {
        this.validQuery = true
        EventBus.$emit('messageAlert', new MessageAlert(this.$t('shared.guardadoCorrecto').toString(), 'success'))
      }).then(() => {
        this.setProcesedAuctionA(true)
        this.$router.push({ name: 'AuctionB', params: { procedureId: this.currentProcedure.procedureId } })
      })
      .catch((error) => {
        this.validQuery = false
        console.log(error)
        let message = this.$t('shared.apiErrors.error_code_auction_a_generic')
        if (error.message === 'error_code_auction_repeated') {
          message = this.$t('shared.apiErrors.error_code_auction_repeated')
        }
        if (error.message === 'error_code_auction_params') {
          message = this.$t('shared.apiErrors.error_code_auction_params')
        }
        EventBus.$emit('messageAlert', new MessageAlert(message.toString(), 'error', 10000))
      })
      .finally(() => {
        EventBus.$emit('loading', false)
      })
  }
}
